import { Col, Row } from "./RowCol";
import {
    useState,
    useEffect,
    useRef,
} from "react";
import CanvasDraw from "react-canvas-draw";
import { Button } from "./button";
import { message, useFile } from "./ot";
import styled from "styled-components";

const Signature = ({
    defaultWidth = 270,
    height = 200,
    onConfirm = () => { },
    disabled = false,
    getApi = "/utility/file/blob",
    defaultValue,
}) => {
    const colRef = useRef();
    const signRef = useRef();
    const [cavasWidth, setcavasWidth] = useState(defaultWidth);
    const [canvasShow, setCanvasShow] = useState(true);
    const [ImgFile, setImgFile] = useState(false);

    const change_weight = () => {
        setcavasWidth(colRef.current.offsetWidth - 8);
    };
    useEffect(() => {
        window.addEventListener("resize", change_weight);
        return () => {
            window.removeEventListener("resize", change_weight);
        };
    }, []);


    const handleSaveImg = () => {
        let canvas;
        canvas = signRef.current.canvasContainer.childNodes[1];
        let dataURL = canvas.toDataURL("image/png");
        let byteString = atob(dataURL.split(",")[1]);
        var mimeString = dataURL.split(",")[0].split(":")[1].split(";")[0];
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        var inputblob = new Blob([ia], { type: mimeString });
        var file = new File([inputblob], "name.png");
        postFileData({
            data: file,
        });
    };

    const clearImg = () => {
        setImgFile(false)
        setCanvasShow(true)
        signRef.current.eraseAll();
    };

    const { postFileData } = useFile({
        apiRoute: '/component/file',
        onFinish: ({ axiosMode, status, values }) => {
            if (status === "success") {
                if (axiosMode === "post") {
                    message.success("檔案上傳成功");
                    let file_id = parseInt(values?.file_id);
                    let temp = [
                        {
                            file_id: file_id,
                            data: values,
                        },
                    ];
                    let data = temp.map((value) => {
                        return {
                            ...value,
                            file_id: value?.file_id,
                        };
                    });
                    setFileId(data?.[0]?.data?.file_id?.file_id)
                    setImgFile(true)
                    setCanvasShow(false)
                    onConfirm(data)
                } else if (axiosMode === "patch") {
                    message.success("修改成功");
                } else if (axiosMode === "delete") {
                    message.success("刪除成功");
                }
            }
        },
    });
    useEffect(() => {
        if (defaultValue) {
            setFileId(defaultValue?.[0]?.file_id)
            setImgFile(true)
            setCanvasShow(false)
        }
    }, [defaultValue]);

    const [fileId, setFileId] = useState(0);
    return (
        <>
            <Row gutter={[8, 8]}>
                <Col span={24} ref={colRef}>
                    {canvasShow && (
                        <CanvasDraw
                            disabled={disabled}
                            ref={signRef}
                            brushColor={"black"}
                            brushRadius={1}
                            lazyRadius={2}
                            hideGrid={true}
                            enablePanAndZoom={true}
                            canvasHeight={height}
                            canvasWidth={cavasWidth}
                            id="canvas"
                            style={{
                                border: "solid #cecece",
                            }}
                        ></CanvasDraw>
                    )}
                </Col>
                {ImgFile && (
                    <Col span={24}>
                        <Image file_id={fileId} key={fileId} getApi={getApi}></Image>
                    </Col>
                )}
                <Col span={24}>
                    <Row gutter={[8, 8]}>
                        <Col xs={24} sm={12}>
                            <ConfirmButton
                                block
                                disabled={disabled}
                                onClick={handleSaveImg}
                            >
                                確認簽名
                            </ConfirmButton>
                        </Col>

                        <Col xs={24} sm={12}>
                            <ResetButton
                                block
                                disabled={disabled}
                                onClick={clearImg}
                            >
                                重寫
                            </ResetButton>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};
export default Signature;

const Image = ({
    file_id = 0,
    getApi = "/utility/file/blob",
}) => {
    const { //output  對於recordcontroller
        FileData,
        getFileData,
    } = useFile({  //input
        getApi: getApi,
    })
    useEffect(() => {
        getFileData({ file_id })
    }, [file_id])
    var blob_ = new Blob([FileData], {
        type: "image/jpg",// this is the only MIME for SVG

    });
    const dataurl = URL.createObjectURL(blob_);
    return <>
        <img
            src={dataurl}
        />
    </>
}


const ConfirmButton = styled.button`
    width: 100%;
    height: 42px;

    background: linear-gradient(135deg, #f6ad55, #ed8936);
    border: none;
    color: #fff;

    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;

    transition: all 0.2s ease;

    &:hover {
        background: linear-gradient(135deg, #ed8936, #dd6b20);
        transform: translateY(-1px);
    }

    &:active {
        transform: scale(0.97);
    }

    &:disabled {
        background: #eee;
        color: #aaa;
        cursor: not-allowed;
        transform: none;
    }
`;

const ResetButton = styled.button`
    width: 100%;
    height: 42px;

    background: #f7c59f;
    border: none;
    color: #333;

    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;

    transition: all 0.2s ease;

    &:hover {
        background: #f28482;
        color: #fff;
    }

    &:active {
        transform: scale(0.97);
    }

    &:disabled {
        background: #eee;
        color: #aaa;
        cursor: not-allowed;
        transform: none;
    }
`;

